
import Vue from "vue";
import axiosBase from "axios";
import { getLocaleForLegalDocuments } from "@/lib/utils/i18n/locale";

// microCMS APIのレスポンス型定義
interface MicroCMSTermsContent {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  type: string[];
  html: string;
  locale: string[];
}

interface MicroCMSResponse {
  contents: MicroCMSTermsContent[];
}

// axiosインスタンスの作成
const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
  data() {
    return {
      isLoading: true,
      error: null as string | null,
      termsContent: null as string | null,
    };
  },
  async created() {
    await this.fetchTermsContent();
  },
  methods: {
    async fetchTermsContent() {
      try {
        this.isLoading = true;
        this.error = null;

        // 利用規約用のロケールを取得（Intl APIを使用）
        const microCMSLocale = getLocaleForLegalDocuments();

        // フィルターを構築
        const localeFilter = `type[contains]terms[and]locale[contains]${microCMSLocale}`;

        // microCMSから利用規約を取得
        // type=termsとlocaleで絞り込んで取得
        const termsRequest = await axios.get<MicroCMSResponse>(`/docs?filters=${localeFilter}`);

        if (termsRequest.status !== 200) {
          throw new Error("Failed to fetch terms of service");
        }

        const responseData = termsRequest.data;

        // データの存在確認とバリデーション
        if (!responseData?.contents || !Array.isArray(responseData.contents) || responseData.contents.length === 0) {
          throw new Error("Terms of service data not found");
        }

        // 最初のコンテンツを取得
        const terms = responseData.contents[0];

        if (!terms?.html) {
          throw new Error("Terms of service HTML content not found");
        }

        // microCMSから取得したHTMLをそのまま設定
        this.termsContent = terms.html;
      } catch (error) {
        console.error("Failed to fetch terms content:", error);
        this.error = error instanceof Error ? error.message : "An unknown error occurred";
      } finally {
        this.isLoading = false;
      }
    },
  },
});
